import { merge } from "theme-ui"
import originalTheme from "@lekoarts/gatsby-theme-minimal-blog/src/gatsby-plugin-theme-ui"

// Extend the theme only to give Markdown tables readable styling:
// cell padding, visible borders, a header background, and horizontal
// scrolling on narrow viewports so wide release-notes tables don't break.
const theme = merge(originalTheme, {
  styles: {
    table: {
      display: `block`,
      overflowX: `auto`,
      width: `100%`,
      my: 4,
      borderCollapse: `collapse`,
      fontSize: [0, 1],
      th: {
        textAlign: `left`,
        px: `12px`,
        py: `8px`,
        bg: `muted`,
        borderWidth: `1px`,
        borderStyle: `solid`,
        borderColor: `muted`,
        whiteSpace: `nowrap`,
      },
      td: {
        textAlign: `left`,
        px: `12px`,
        py: `8px`,
        borderWidth: `1px`,
        borderStyle: `solid`,
        borderColor: `muted`,
        verticalAlign: `top`,
      },
    },
  },
})

export default theme
